import React from 'react';
import ReactDOM from 'react-dom/client';
import { ReduxCheck } from '../redux-check/ReduxCheck';
import { AudioRecorder } from '../audio-recorder';
import { Asr } from '../asr';
import { Result } from '../result';
import { useState, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import TranslationNLP from '../translation/TranslationNLP';
import AudioRecorderNLP from '../audio-recorder/AudioRecorderNLP';
import AsrNLP from '../asr/AsrNLP';

const CardNLP = () => {

    return (
        <Container style={{"background": "#f1f1f0"}}>
            <Row>
                <Col>
                    <div className="card-default">
                        <div>
                            <AudioRecorderNLP />
                            <AsrNLP />
                            <TranslationNLP />
                            <Result />                      
                        </div>
                    </div>
                </Col>
                {/* <Col></Col> */}
            </Row>
        </Container>

    );
};


export default CardNLP;